import { prepareOwnerMember } from '../member/prepare-owner-member';
import { prepareInvitationCommon, } from './prepare-invitation-common';
export const prepareOwnerInvitation = async (params) => {
    const { invitation, invitationKeys } = await prepareInvitationCommon(params);
    const owner = await prepareOwnerMember({
        userKey: params.userKey,
        adminKeys: params.adminKeys,
        workspaceId: params.workspaceId,
        invitationKeys,
    });
    return {
        ...invitation,
        owner,
    };
};
